/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/plant'
export default icon
